import React from 'react'

const Forward = ({ onClick }) => (
  <svg
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 456.551 456.551"
    width="1.5em"
    height="1.5em"
  >
    <g>
      <path
        d="M16.195,456.551c-1.937,0-3.882-0.42-5.693-1.266c-4.721-2.21-7.735-6.952-7.735-12.162v-429.7   c0-5.21,3.014-9.952,7.735-12.162c4.7-2.196,10.281-1.49,14.288,1.846l257.82,214.85c3.063,2.553,4.833,6.329,4.833,10.316   c0,3.986-1.769,7.763-4.833,10.316l-257.82,214.85C22.329,455.488,19.28,456.551,16.195,456.551z M29.624,42.091v372.364   l223.417-186.182L29.624,42.091z"
        fill="#FFFFFF"
      />
      <path
        d="M182.536,456.551c-1.937,0-3.882-0.42-5.693-1.266c-4.721-2.21-7.735-6.952-7.735-12.162v-66.532   c0-7.413,6.015-13.428,13.428-13.428s13.428,6.015,13.428,13.428v37.865l223.417-186.182L195.964,42.091v37.864   c0,7.413-6.015,13.428-13.428,13.428s-13.428-6.015-13.428-13.428V13.424c0-5.21,3.014-9.952,7.735-12.162   c4.693-2.196,10.281-1.49,14.288,1.846l257.82,214.85c3.063,2.553,4.833,6.329,4.833,10.316c0,3.986-1.769,7.763-4.833,10.316   l-257.82,214.85C188.67,455.488,185.62,456.551,182.536,456.551z"
        fill="#FFFFFF"
      />
    </g>
  </svg>
)

export default Forward